module.exports = "/images/SetUpYourCompany-4.jpg";